module.exports = __webpack_public_path__ + "static/media/moonsLogo.745ab4d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moonsLogo.svg
// module id = 498
// module chunks = 0